var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.open,
        persistent: "",
        "max-width": "350",
        "content-class": "request-field-item-dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "home-form-container", attrs: { color: "#f0f0ef" } },
        [
          _c(
            "v-card-text",
            {
              staticClass: "home-form-container",
              staticStyle: {
                "text-align": "left",
                padding: "4px 0 0 0",
                overflow: "visible"
              }
            },
            [
              _c("input-field", {
                attrs: {
                  label: _vm.$tc("Code", 1),
                  "input-type": "text",
                  min: "0",
                  required: true,
                  size: "100",
                  badLabel: _vm.checkCode,
                  limit: "32"
                },
                on: { "check-alphanumeric": _vm.checkAlphanumeric },
                model: {
                  value: _vm.listValueData.code,
                  callback: function($$v) {
                    _vm.$set(_vm.listValueData, "code", $$v)
                  },
                  expression: "listValueData.code"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$tc("Label", 1),
                  size: "100",
                  "max-length": "255",
                  "input-type": "text",
                  badLabel: _vm.checkLabel,
                  limit: "255",
                  required: true
                },
                model: {
                  value: _vm.listValueData.libelle,
                  callback: function($$v) {
                    _vm.$set(_vm.listValueData, "libelle", $$v)
                  },
                  expression: "listValueData.libelle"
                }
              }),
              _vm._v(" "),
              !_vm.isCustomList
                ? _c("input-field", {
                    attrs: {
                      label: _vm.$t("ClientCode"),
                      max: "3",
                      size: "100",
                      "input-type": "text"
                    },
                    model: {
                      value: _vm.listValueData.client_code,
                      callback: function($$v) {
                        _vm.$set(_vm.listValueData, "client_code", $$v)
                      },
                      expression: "listValueData.client_code"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCustomList
                ? _c("input-field", {
                    attrs: {
                      label: _vm.$t("ClientLabel"),
                      size: "100",
                      "input-type": "text"
                    },
                    model: {
                      value: _vm.listValueData.client_label,
                      callback: function($$v) {
                        _vm.$set(_vm.listValueData, "client_label", $$v)
                      },
                      expression: "listValueData.client_label"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCustomList
                ? _c("input-field", {
                    attrs: {
                      label: _vm.$t("Definition"),
                      size: "100",
                      "input-type": "text"
                    },
                    model: {
                      value: _vm.listValueData.definition,
                      callback: function($$v) {
                        _vm.$set(_vm.listValueData, "definition", $$v)
                      },
                      expression: "listValueData.definition"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Index"),
                  size: "100",
                  "input-type": "int",
                  min: "0"
                },
                model: {
                  value: _vm.listValueData.index,
                  callback: function($$v) {
                    _vm.$set(_vm.listValueData, "index", $$v)
                  },
                  expression: "listValueData.index"
                }
              }),
              _vm._v(" "),
              !_vm.isCustomList
                ? _c(
                    "div",
                    { staticClass: "input-field" },
                    [
                      _c("label", { attrs: { for: "deleted" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Blocked")) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          attrs: { id: "deleted", mandatory: "", row: "" },
                          model: {
                            value: _vm.listValueData.blocked,
                            callback: function($$v) {
                              _vm.$set(_vm.listValueData, "blocked", $$v)
                            },
                            expression: "listValueData.blocked"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t("Yes"),
                              value: true,
                              ripple: false,
                              color: "accent"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t("No"),
                              value: false,
                              ripple: false,
                              color: "accent"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCustomList
                ? _c(
                    "div",
                    { staticClass: "input-field" },
                    [
                      _c("label", { attrs: { for: "deleted" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Hidden")) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          attrs: { id: "deleted", mandatory: "", row: "" },
                          model: {
                            value: _vm.listValueData.deleted,
                            callback: function($$v) {
                              _vm.$set(_vm.listValueData, "deleted", $$v)
                            },
                            expression: "listValueData.deleted"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t("Yes"),
                              value: true,
                              ripple: false,
                              color: "accent"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t("No"),
                              value: false,
                              ripple: false,
                              color: "accent"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            {
              staticStyle: { "padding-right": "20px", "padding-bottom": "12px" }
            },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c("management-button", {
                attrs: { type: "cancel", label: _vm.$t("Cancel") },
                on: { buttonClick: _vm.close }
              }),
              _vm._v(" "),
              _c("management-button", {
                attrs: {
                  type: "execute",
                  label: _vm.$t("Create"),
                  disabled: !_vm.requiredAreFilled
                },
                on: { buttonClick: _vm.applyChanges }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42ed5968", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ed5968","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/ListItemPopupForm.vue
// module id = null
// module chunks = 